import flowSensorApi from '@/api/config/flowSensorApi'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'

const useSearchFlowSensorId = (interfaceId: number, id: number) => {
  return useQuery({
    queryKey: [queryKeys.flowSensorDetail, id],
    queryFn: async () => {
      const { data } = await flowSensorApi.getById(interfaceId, id)
      if (!data) return null
      return data
    },
    onError: (error: any) => {
      toast.error(error?.message)
    },
    enabled: !!id,
  })
}

export default useSearchFlowSensorId
